export const googleFonts = {
    "ABeeZee": {
        "family": "ABeeZee",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "ADLaM-Display": {
        "family": "ADLaM Display",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "AR-One-Sans": {
        "family": "AR One Sans",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Abel": {
        "family": "Abel",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Abhaya-Libre": {
        "family": "Abhaya Libre",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Aboreto": {
        "family": "Aboreto",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Abril-Fatface": {
        "family": "Abril Fatface",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Abyssinica-SIL": {
        "family": "Abyssinica SIL",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Aclonica": {
        "family": "Aclonica",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Acme": {
        "family": "Acme",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Actor": {
        "family": "Actor",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Adamina": {
        "family": "Adamina",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Advent-Pro": {
        "family": "Advent Pro",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Afacad": {
        "family": "Afacad",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Agbalumo": {
        "family": "Agbalumo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Agdasima": {
        "family": "Agdasima",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Aguafina-Script": {
        "family": "Aguafina Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Akatab": {
        "family": "Akatab",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Akaya-Kanadaka": {
        "family": "Akaya Kanadaka",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Akaya-Telivigala": {
        "family": "Akaya Telivigala",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Akronim": {
        "family": "Akronim",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Akshar": {
        "family": "Akshar",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Aladin": {
        "family": "Aladin",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Alata": {
        "family": "Alata",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Alatsi": {
        "family": "Alatsi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Albert-Sans": {
        "family": "Albert Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Aldrich": {
        "family": "Aldrich",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Alef": {
        "family": "Alef",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Alegreya": {
        "family": "Alegreya",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Alegreya-SC": {
        "family": "Alegreya SC",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "500",
            "500italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Alegreya-Sans": {
        "family": "Alegreya Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Alegreya-Sans-SC": {
        "family": "Alegreya Sans SC",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Aleo": {
        "family": "Aleo",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Alex-Brush": {
        "family": "Alex Brush",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Alexandria": {
        "family": "Alexandria",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Alfa-Slab-One": {
        "family": "Alfa Slab One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Alice": {
        "family": "Alice",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Alike": {
        "family": "Alike",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Alike-Angular": {
        "family": "Alike Angular",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Alkalami": {
        "family": "Alkalami",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Alkatra": {
        "family": "Alkatra",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Allan": {
        "family": "Allan",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Allerta": {
        "family": "Allerta",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Allerta-Stencil": {
        "family": "Allerta Stencil",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Allison": {
        "family": "Allison",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Allura": {
        "family": "Allura",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Almarai": {
        "family": "Almarai",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "700",
            "800"
        ]
    },
    "Almendra": {
        "family": "Almendra",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Almendra-Display": {
        "family": "Almendra Display",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Almendra-SC": {
        "family": "Almendra SC",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Alumni-Sans": {
        "family": "Alumni Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Alumni-Sans-Collegiate-One": {
        "family": "Alumni Sans Collegiate One",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Alumni-Sans-Inline-One": {
        "family": "Alumni Sans Inline One",
        "category": "display",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Alumni-Sans-Pinstripe": {
        "family": "Alumni Sans Pinstripe",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Amarante": {
        "family": "Amarante",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Amaranth": {
        "family": "Amaranth",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Amatic-SC": {
        "family": "Amatic SC",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Amethysta": {
        "family": "Amethysta",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Amiko": {
        "family": "Amiko",
        "category": "sans-serif",
        "variants": [
            "regular",
            "600",
            "700"
        ]
    },
    "Amiri": {
        "family": "Amiri",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Amiri-Quran": {
        "family": "Amiri Quran",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Amita": {
        "family": "Amita",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Anaheim": {
        "family": "Anaheim",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Andada-Pro": {
        "family": "Andada Pro",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Andika": {
        "family": "Andika",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Anek-Bangla": {
        "family": "Anek Bangla",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Anek-Devanagari": {
        "family": "Anek Devanagari",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Anek-Gujarati": {
        "family": "Anek Gujarati",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Anek-Gurmukhi": {
        "family": "Anek Gurmukhi",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Anek-Kannada": {
        "family": "Anek Kannada",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Anek-Latin": {
        "family": "Anek Latin",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Anek-Malayalam": {
        "family": "Anek Malayalam",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Anek-Odia": {
        "family": "Anek Odia",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Anek-Tamil": {
        "family": "Anek Tamil",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Anek-Telugu": {
        "family": "Anek Telugu",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Angkor": {
        "family": "Angkor",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Annapurna-SIL": {
        "family": "Annapurna SIL",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Annie-Use-Your-Telescope": {
        "family": "Annie Use Your Telescope",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Anonymous-Pro": {
        "family": "Anonymous Pro",
        "category": "monospace",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Anta": {
        "family": "Anta",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Antic": {
        "family": "Antic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Antic-Didone": {
        "family": "Antic Didone",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Antic-Slab": {
        "family": "Antic Slab",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Anton": {
        "family": "Anton",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Antonio": {
        "family": "Antonio",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Anuphan": {
        "family": "Anuphan",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Anybody": {
        "family": "Anybody",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Aoboshi-One": {
        "family": "Aoboshi One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Arapey": {
        "family": "Arapey",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Arbutus": {
        "family": "Arbutus",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Arbutus-Slab": {
        "family": "Arbutus Slab",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Architects-Daughter": {
        "family": "Architects Daughter",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Archivo": {
        "family": "Archivo",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Archivo-Black": {
        "family": "Archivo Black",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Archivo-Narrow": {
        "family": "Archivo Narrow",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Are-You-Serious": {
        "family": "Are You Serious",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Aref-Ruqaa": {
        "family": "Aref Ruqaa",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Aref-Ruqaa-Ink": {
        "family": "Aref Ruqaa Ink",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Arima": {
        "family": "Arima",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Arimo": {
        "family": "Arimo",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Arizonia": {
        "family": "Arizonia",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Armata": {
        "family": "Armata",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Arsenal": {
        "family": "Arsenal",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Artifika": {
        "family": "Artifika",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Arvo": {
        "family": "Arvo",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Arya": {
        "family": "Arya",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Asap": {
        "family": "Asap",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Asap-Condensed": {
        "family": "Asap Condensed",
        "category": "sans-serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Asar": {
        "family": "Asar",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Asset": {
        "family": "Asset",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Assistant": {
        "family": "Assistant",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Astloch": {
        "family": "Astloch",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Asul": {
        "family": "Asul",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Athiti": {
        "family": "Athiti",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Atkinson-Hyperlegible": {
        "family": "Atkinson Hyperlegible",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Atma": {
        "family": "Atma",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Atomic-Age": {
        "family": "Atomic Age",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Aubrey": {
        "family": "Aubrey",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Audiowide": {
        "family": "Audiowide",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Autour-One": {
        "family": "Autour One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Average": {
        "family": "Average",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Average-Sans": {
        "family": "Average Sans",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Averia-Gruesa-Libre": {
        "family": "Averia Gruesa Libre",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Averia-Libre": {
        "family": "Averia Libre",
        "category": "display",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Averia-Sans-Libre": {
        "family": "Averia Sans Libre",
        "category": "display",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Averia-Serif-Libre": {
        "family": "Averia Serif Libre",
        "category": "display",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Azeret-Mono": {
        "family": "Azeret Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "B612": {
        "family": "B612",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "B612-Mono": {
        "family": "B612 Mono",
        "category": "monospace",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "BIZ-UDGothic": {
        "family": "BIZ UDGothic",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "BIZ-UDMincho": {
        "family": "BIZ UDMincho",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "BIZ-UDPGothic": {
        "family": "BIZ UDPGothic",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "BIZ-UDPMincho": {
        "family": "BIZ UDPMincho",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Babylonica": {
        "family": "Babylonica",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Bacasime-Antique": {
        "family": "Bacasime Antique",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Bad-Script": {
        "family": "Bad Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Bagel-Fat-One": {
        "family": "Bagel Fat One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bahiana": {
        "family": "Bahiana",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bahianita": {
        "family": "Bahianita",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bai-Jamjuree": {
        "family": "Bai Jamjuree",
        "category": "sans-serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Bakbak-One": {
        "family": "Bakbak One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Ballet": {
        "family": "Ballet",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Baloo-2": {
        "family": "Baloo 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Baloo-Bhai-2": {
        "family": "Baloo Bhai 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Baloo-Bhaijaan-2": {
        "family": "Baloo Bhaijaan 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Baloo-Bhaina-2": {
        "family": "Baloo Bhaina 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Baloo-Chettan-2": {
        "family": "Baloo Chettan 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Baloo-Da-2": {
        "family": "Baloo Da 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Baloo-Paaji-2": {
        "family": "Baloo Paaji 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Baloo-Tamma-2": {
        "family": "Baloo Tamma 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Baloo-Tammudu-2": {
        "family": "Baloo Tammudu 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Baloo-Thambi-2": {
        "family": "Baloo Thambi 2",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Balsamiq-Sans": {
        "family": "Balsamiq Sans",
        "category": "display",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Balthazar": {
        "family": "Balthazar",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Bangers": {
        "family": "Bangers",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Barlow": {
        "family": "Barlow",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Barlow-Condensed": {
        "family": "Barlow Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Barlow-Semi-Condensed": {
        "family": "Barlow Semi Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Barriecito": {
        "family": "Barriecito",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Barrio": {
        "family": "Barrio",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Basic": {
        "family": "Basic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Baskervville": {
        "family": "Baskervville",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Battambang": {
        "family": "Battambang",
        "category": "display",
        "variants": [
            "100",
            "300",
            "regular",
            "700",
            "900"
        ]
    },
    "Baumans": {
        "family": "Baumans",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bayon": {
        "family": "Bayon",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Be-Vietnam-Pro": {
        "family": "Be Vietnam Pro",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Beau-Rivage": {
        "family": "Beau Rivage",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Bebas-Neue": {
        "family": "Bebas Neue",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Belanosima": {
        "family": "Belanosima",
        "category": "sans-serif",
        "variants": [
            "regular",
            "600",
            "700"
        ]
    },
    "Belgrano": {
        "family": "Belgrano",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Bellefair": {
        "family": "Bellefair",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Belleza": {
        "family": "Belleza",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Bellota": {
        "family": "Bellota",
        "category": "display",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Bellota-Text": {
        "family": "Bellota Text",
        "category": "display",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "BenchNine": {
        "family": "BenchNine",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "700"
        ]
    },
    "Benne": {
        "family": "Benne",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Bentham": {
        "family": "Bentham",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Berkshire-Swash": {
        "family": "Berkshire Swash",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Besley": {
        "family": "Besley",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Beth-Ellen": {
        "family": "Beth Ellen",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Bevan": {
        "family": "Bevan",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "BhuTuka-Expanded-One": {
        "family": "BhuTuka Expanded One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Big-Shoulders-Display": {
        "family": "Big Shoulders Display",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Big-Shoulders-Inline-Display": {
        "family": "Big Shoulders Inline Display",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Big-Shoulders-Inline-Text": {
        "family": "Big Shoulders Inline Text",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Big-Shoulders-Stencil-Display": {
        "family": "Big Shoulders Stencil Display",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Big-Shoulders-Stencil-Text": {
        "family": "Big Shoulders Stencil Text",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Big-Shoulders-Text": {
        "family": "Big Shoulders Text",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Bigelow-Rules": {
        "family": "Bigelow Rules",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bigshot-One": {
        "family": "Bigshot One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bilbo": {
        "family": "Bilbo",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Bilbo-Swash-Caps": {
        "family": "Bilbo Swash Caps",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "BioRhyme": {
        "family": "BioRhyme",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "BioRhyme-Expanded": {
        "family": "BioRhyme Expanded",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "700",
            "800"
        ]
    },
    "Birthstone": {
        "family": "Birthstone",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Birthstone-Bounce": {
        "family": "Birthstone Bounce",
        "category": "handwriting",
        "variants": [
            "regular",
            "500"
        ]
    },
    "Biryani": {
        "family": "Biryani",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Bitter": {
        "family": "Bitter",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Black-And-White-Picture": {
        "family": "Black And White Picture",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Black-Han-Sans": {
        "family": "Black Han Sans",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Black-Ops-One": {
        "family": "Black Ops One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Blaka": {
        "family": "Blaka",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Blaka-Hollow": {
        "family": "Blaka Hollow",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Blaka-Ink": {
        "family": "Blaka Ink",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Blinker": {
        "family": "Blinker",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Bodoni-Moda": {
        "family": "Bodoni Moda",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Bokor": {
        "family": "Bokor",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bona-Nova": {
        "family": "Bona Nova",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700"
        ]
    },
    "Bonbon": {
        "family": "Bonbon",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Bonheur-Royale": {
        "family": "Bonheur Royale",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Boogaloo": {
        "family": "Boogaloo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Borel": {
        "family": "Borel",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Bowlby-One": {
        "family": "Bowlby One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bowlby-One-SC": {
        "family": "Bowlby One SC",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Braah-One": {
        "family": "Braah One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Brawler": {
        "family": "Brawler",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Bree-Serif": {
        "family": "Bree Serif",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Bricolage-Grotesque": {
        "family": "Bricolage Grotesque",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Bruno-Ace": {
        "family": "Bruno Ace",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bruno-Ace-SC": {
        "family": "Bruno Ace SC",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Brygada-1918": {
        "family": "Brygada 1918",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Bubblegum-Sans": {
        "family": "Bubblegum Sans",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bubbler-One": {
        "family": "Bubbler One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Buda": {
        "family": "Buda",
        "category": "display",
        "variants": [
            "300"
        ]
    },
    "Buenard": {
        "family": "Buenard",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Bungee": {
        "family": "Bungee",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bungee-Hairline": {
        "family": "Bungee Hairline",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bungee-Inline": {
        "family": "Bungee Inline",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bungee-Outline": {
        "family": "Bungee Outline",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bungee-Shade": {
        "family": "Bungee Shade",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Bungee-Spice": {
        "family": "Bungee Spice",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Butcherman": {
        "family": "Butcherman",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Butterfly-Kids": {
        "family": "Butterfly Kids",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Cabin": {
        "family": "Cabin",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Cabin-Condensed": {
        "family": "Cabin Condensed",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Cabin-Sketch": {
        "family": "Cabin Sketch",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Caesar-Dressing": {
        "family": "Caesar Dressing",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Cagliostro": {
        "family": "Cagliostro",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Cairo": {
        "family": "Cairo",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Cairo-Play": {
        "family": "Cairo Play",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Caladea": {
        "family": "Caladea",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Calistoga": {
        "family": "Calistoga",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Calligraffitti": {
        "family": "Calligraffitti",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Cambay": {
        "family": "Cambay",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Cambo": {
        "family": "Cambo",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Candal": {
        "family": "Candal",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Cantarell": {
        "family": "Cantarell",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Cantata-One": {
        "family": "Cantata One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Cantora-One": {
        "family": "Cantora One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Caprasimo": {
        "family": "Caprasimo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Capriola": {
        "family": "Capriola",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Caramel": {
        "family": "Caramel",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Carattere": {
        "family": "Carattere",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Cardo": {
        "family": "Cardo",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700"
        ]
    },
    "Carlito": {
        "family": "Carlito",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Carme": {
        "family": "Carme",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Carrois-Gothic": {
        "family": "Carrois Gothic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Carrois-Gothic-SC": {
        "family": "Carrois Gothic SC",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Carter-One": {
        "family": "Carter One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Castoro": {
        "family": "Castoro",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Castoro-Titling": {
        "family": "Castoro Titling",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Catamaran": {
        "family": "Catamaran",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Caudex": {
        "family": "Caudex",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Caveat": {
        "family": "Caveat",
        "category": "handwriting",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Caveat-Brush": {
        "family": "Caveat Brush",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Cedarville-Cursive": {
        "family": "Cedarville Cursive",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ceviche-One": {
        "family": "Ceviche One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Chakra-Petch": {
        "family": "Chakra Petch",
        "category": "sans-serif",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Changa": {
        "family": "Changa",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Changa-One": {
        "family": "Changa One",
        "category": "display",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Chango": {
        "family": "Chango",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Charis-SIL": {
        "family": "Charis SIL",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Charm": {
        "family": "Charm",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Charmonman": {
        "family": "Charmonman",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Chathura": {
        "family": "Chathura",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "regular",
            "700",
            "800"
        ]
    },
    "Chau-Philomene-One": {
        "family": "Chau Philomene One",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Chela-One": {
        "family": "Chela One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Chelsea-Market": {
        "family": "Chelsea Market",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Chenla": {
        "family": "Chenla",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Cherish": {
        "family": "Cherish",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Cherry-Bomb-One": {
        "family": "Cherry Bomb One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Cherry-Cream-Soda": {
        "family": "Cherry Cream Soda",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Cherry-Swash": {
        "family": "Cherry Swash",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Chewy": {
        "family": "Chewy",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Chicle": {
        "family": "Chicle",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Chilanka": {
        "family": "Chilanka",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Chivo": {
        "family": "Chivo",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Chivo-Mono": {
        "family": "Chivo Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Chokokutai": {
        "family": "Chokokutai",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Chonburi": {
        "family": "Chonburi",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Cinzel": {
        "family": "Cinzel",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Cinzel-Decorative": {
        "family": "Cinzel Decorative",
        "category": "display",
        "variants": [
            "regular",
            "700",
            "900"
        ]
    },
    "Clicker-Script": {
        "family": "Clicker Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Climate-Crisis": {
        "family": "Climate Crisis",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Coda": {
        "family": "Coda",
        "category": "display",
        "variants": [
            "regular",
            "800"
        ]
    },
    "Codystar": {
        "family": "Codystar",
        "category": "display",
        "variants": [
            "300",
            "regular"
        ]
    },
    "Coiny": {
        "family": "Coiny",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Combo": {
        "family": "Combo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Comfortaa": {
        "family": "Comfortaa",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Comforter": {
        "family": "Comforter",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Comforter-Brush": {
        "family": "Comforter Brush",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Comic-Neue": {
        "family": "Comic Neue",
        "category": "handwriting",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Coming-Soon": {
        "family": "Coming Soon",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Comme": {
        "family": "Comme",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Commissioner": {
        "family": "Commissioner",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Concert-One": {
        "family": "Concert One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Condiment": {
        "family": "Condiment",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Content": {
        "family": "Content",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Contrail-One": {
        "family": "Contrail One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Convergence": {
        "family": "Convergence",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Cookie": {
        "family": "Cookie",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Copse": {
        "family": "Copse",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Corben": {
        "family": "Corben",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Corinthia": {
        "family": "Corinthia",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Cormorant": {
        "family": "Cormorant",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Cormorant-Garamond": {
        "family": "Cormorant Garamond",
        "category": "serif",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Cormorant-Infant": {
        "family": "Cormorant Infant",
        "category": "serif",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Cormorant-SC": {
        "family": "Cormorant SC",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Cormorant-Unicase": {
        "family": "Cormorant Unicase",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Cormorant-Upright": {
        "family": "Cormorant Upright",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Courgette": {
        "family": "Courgette",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Courier-Prime": {
        "family": "Courier Prime",
        "category": "monospace",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Cousine": {
        "family": "Cousine",
        "category": "monospace",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Coustard": {
        "family": "Coustard",
        "category": "serif",
        "variants": [
            "regular",
            "900"
        ]
    },
    "Covered-By-Your-Grace": {
        "family": "Covered By Your Grace",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Crafty-Girls": {
        "family": "Crafty Girls",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Creepster": {
        "family": "Creepster",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Crete-Round": {
        "family": "Crete Round",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Crimson-Pro": {
        "family": "Crimson Pro",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Crimson-Text": {
        "family": "Crimson Text",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Croissant-One": {
        "family": "Croissant One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Crushed": {
        "family": "Crushed",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Cuprum": {
        "family": "Cuprum",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Cute-Font": {
        "family": "Cute Font",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Cutive": {
        "family": "Cutive",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Cutive-Mono": {
        "family": "Cutive Mono",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "DM-Mono": {
        "family": "DM Mono",
        "category": "monospace",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic"
        ]
    },
    "DM-Sans": {
        "family": "DM Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "DM-Serif-Display": {
        "family": "DM Serif Display",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "DM-Serif-Text": {
        "family": "DM Serif Text",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Dai-Banna-SIL": {
        "family": "Dai Banna SIL",
        "category": "serif",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Damion": {
        "family": "Damion",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Dancing-Script": {
        "family": "Dancing Script",
        "category": "handwriting",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Dangrek": {
        "family": "Dangrek",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Darker-Grotesque": {
        "family": "Darker Grotesque",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Darumadrop-One": {
        "family": "Darumadrop One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "David-Libre": {
        "family": "David Libre",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "700"
        ]
    },
    "Dawning-of-a-New-Day": {
        "family": "Dawning of a New Day",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Days-One": {
        "family": "Days One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Dekko": {
        "family": "Dekko",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Dela-Gothic-One": {
        "family": "Dela Gothic One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Delicious-Handrawn": {
        "family": "Delicious Handrawn",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Delius": {
        "family": "Delius",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Delius-Swash-Caps": {
        "family": "Delius Swash Caps",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Delius-Unicase": {
        "family": "Delius Unicase",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Della-Respira": {
        "family": "Della Respira",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Denk-One": {
        "family": "Denk One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Devonshire": {
        "family": "Devonshire",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Dhurjati": {
        "family": "Dhurjati",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Didact-Gothic": {
        "family": "Didact Gothic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Diphylleia": {
        "family": "Diphylleia",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Diplomata": {
        "family": "Diplomata",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Diplomata-SC": {
        "family": "Diplomata SC",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Do-Hyeon": {
        "family": "Do Hyeon",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Dokdo": {
        "family": "Dokdo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Domine": {
        "family": "Domine",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Donegal-One": {
        "family": "Donegal One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Dongle": {
        "family": "Dongle",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "700"
        ]
    },
    "Doppio-One": {
        "family": "Doppio One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Dorsa": {
        "family": "Dorsa",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Dosis": {
        "family": "Dosis",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "DotGothic16": {
        "family": "DotGothic16",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Dr-Sugiyama": {
        "family": "Dr Sugiyama",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Duru-Sans": {
        "family": "Duru Sans",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "DynaPuff": {
        "family": "DynaPuff",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Dynalight": {
        "family": "Dynalight",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "EB-Garamond": {
        "family": "EB Garamond",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Eagle-Lake": {
        "family": "Eagle Lake",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "East-Sea-Dokdo": {
        "family": "East Sea Dokdo",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Eater": {
        "family": "Eater",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Economica": {
        "family": "Economica",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Eczar": {
        "family": "Eczar",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Edu-NSW-ACT-Foundation": {
        "family": "Edu NSW ACT Foundation",
        "category": "handwriting",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Edu-QLD-Beginner": {
        "family": "Edu QLD Beginner",
        "category": "handwriting",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Edu-SA-Beginner": {
        "family": "Edu SA Beginner",
        "category": "handwriting",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Edu-TAS-Beginner": {
        "family": "Edu TAS Beginner",
        "category": "handwriting",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Edu-VIC-WA-NT-Beginner": {
        "family": "Edu VIC WA NT Beginner",
        "category": "handwriting",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "El-Messiri": {
        "family": "El Messiri",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Electrolize": {
        "family": "Electrolize",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Elsie": {
        "family": "Elsie",
        "category": "display",
        "variants": [
            "regular",
            "900"
        ]
    },
    "Elsie-Swash-Caps": {
        "family": "Elsie Swash Caps",
        "category": "display",
        "variants": [
            "regular",
            "900"
        ]
    },
    "Emblema-One": {
        "family": "Emblema One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Emilys-Candy": {
        "family": "Emilys Candy",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Encode-Sans": {
        "family": "Encode Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Encode-Sans-Condensed": {
        "family": "Encode Sans Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Encode-Sans-Expanded": {
        "family": "Encode Sans Expanded",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Encode-Sans-SC": {
        "family": "Encode Sans SC",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Encode-Sans-Semi-Condensed": {
        "family": "Encode Sans Semi Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Encode-Sans-Semi-Expanded": {
        "family": "Encode Sans Semi Expanded",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Engagement": {
        "family": "Engagement",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Englebert": {
        "family": "Englebert",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Enriqueta": {
        "family": "Enriqueta",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Ephesis": {
        "family": "Ephesis",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Epilogue": {
        "family": "Epilogue",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Erica-One": {
        "family": "Erica One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Esteban": {
        "family": "Esteban",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Estonia": {
        "family": "Estonia",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Euphoria-Script": {
        "family": "Euphoria Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ewert": {
        "family": "Ewert",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Exo": {
        "family": "Exo",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Exo-2": {
        "family": "Exo 2",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Expletus-Sans": {
        "family": "Expletus Sans",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Explora": {
        "family": "Explora",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Fahkwang": {
        "family": "Fahkwang",
        "category": "sans-serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Familjen-Grotesk": {
        "family": "Familjen Grotesk",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Fanwood-Text": {
        "family": "Fanwood Text",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Farro": {
        "family": "Farro",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "700"
        ]
    },
    "Farsan": {
        "family": "Farsan",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fascinate": {
        "family": "Fascinate",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fascinate-Inline": {
        "family": "Fascinate Inline",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Faster-One": {
        "family": "Faster One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fasthand": {
        "family": "Fasthand",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fauna-One": {
        "family": "Fauna One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Faustina": {
        "family": "Faustina",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Federant": {
        "family": "Federant",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Federo": {
        "family": "Federo",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Felipa": {
        "family": "Felipa",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Fenix": {
        "family": "Fenix",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Festive": {
        "family": "Festive",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Figtree": {
        "family": "Figtree",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Finger-Paint": {
        "family": "Finger Paint",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Finlandica": {
        "family": "Finlandica",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Fira-Code": {
        "family": "Fira Code",
        "category": "monospace",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Fira-Mono": {
        "family": "Fira Mono",
        "category": "monospace",
        "variants": [
            "regular",
            "500",
            "700"
        ]
    },
    "Fira-Sans": {
        "family": "Fira Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Fira-Sans-Condensed": {
        "family": "Fira Sans Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Fira-Sans-Extra-Condensed": {
        "family": "Fira Sans Extra Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Fjalla-One": {
        "family": "Fjalla One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Fjord-One": {
        "family": "Fjord One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Flamenco": {
        "family": "Flamenco",
        "category": "display",
        "variants": [
            "300",
            "regular"
        ]
    },
    "Flavors": {
        "family": "Flavors",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fleur-De-Leah": {
        "family": "Fleur De Leah",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Flow-Block": {
        "family": "Flow Block",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Flow-Circular": {
        "family": "Flow Circular",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Flow-Rounded": {
        "family": "Flow Rounded",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Foldit": {
        "family": "Foldit",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Fondamento": {
        "family": "Fondamento",
        "category": "handwriting",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Fontdiner-Swanky": {
        "family": "Fontdiner Swanky",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Forum": {
        "family": "Forum",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fragment-Mono": {
        "family": "Fragment Mono",
        "category": "monospace",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Francois-One": {
        "family": "Francois One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Frank-Ruhl-Libre": {
        "family": "Frank Ruhl Libre",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Fraunces": {
        "family": "Fraunces",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Freckle-Face": {
        "family": "Freckle Face",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fredericka-the-Great": {
        "family": "Fredericka the Great",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fredoka": {
        "family": "Fredoka",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Freehand": {
        "family": "Freehand",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fresca": {
        "family": "Fresca",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Frijole": {
        "family": "Frijole",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fruktur": {
        "family": "Fruktur",
        "category": "display",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Fugaz-One": {
        "family": "Fugaz One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Fuggles": {
        "family": "Fuggles",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Fuzzy-Bubbles": {
        "family": "Fuzzy Bubbles",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "GFS-Didot": {
        "family": "GFS Didot",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "GFS-Neohellenic": {
        "family": "GFS Neohellenic",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Gabarito": {
        "family": "Gabarito",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Gabriela": {
        "family": "Gabriela",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Gaegu": {
        "family": "Gaegu",
        "category": "handwriting",
        "variants": [
            "300",
            "regular",
            "700"
        ]
    },
    "Gafata": {
        "family": "Gafata",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Gajraj-One": {
        "family": "Gajraj One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Galada": {
        "family": "Galada",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Galdeano": {
        "family": "Galdeano",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Galindo": {
        "family": "Galindo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Gamja-Flower": {
        "family": "Gamja Flower",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Gantari": {
        "family": "Gantari",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Gasoek-One": {
        "family": "Gasoek One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Gayathri": {
        "family": "Gayathri",
        "category": "sans-serif",
        "variants": [
            "100",
            "regular",
            "700"
        ]
    },
    "Gelasio": {
        "family": "Gelasio",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Gemunu-Libre": {
        "family": "Gemunu Libre",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Genos": {
        "family": "Genos",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Gentium-Book-Plus": {
        "family": "Gentium Book Plus",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Gentium-Plus": {
        "family": "Gentium Plus",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Geo": {
        "family": "Geo",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Geologica": {
        "family": "Geologica",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Georama": {
        "family": "Georama",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Geostar": {
        "family": "Geostar",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Geostar-Fill": {
        "family": "Geostar Fill",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Germania-One": {
        "family": "Germania One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Gideon-Roman": {
        "family": "Gideon Roman",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Gidugu": {
        "family": "Gidugu",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Gilda-Display": {
        "family": "Gilda Display",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Girassol": {
        "family": "Girassol",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Give-You-Glory": {
        "family": "Give You Glory",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Glass-Antiqua": {
        "family": "Glass Antiqua",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Glegoo": {
        "family": "Glegoo",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Gloock": {
        "family": "Gloock",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Gloria-Hallelujah": {
        "family": "Gloria Hallelujah",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Glory": {
        "family": "Glory",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Gluten": {
        "family": "Gluten",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Goblin-One": {
        "family": "Goblin One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Gochi-Hand": {
        "family": "Gochi Hand",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Goldman": {
        "family": "Goldman",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Golos-Text": {
        "family": "Golos Text",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Gorditas": {
        "family": "Gorditas",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Gothic-A1": {
        "family": "Gothic A1",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Gotu": {
        "family": "Gotu",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Goudy-Bookletter-1911": {
        "family": "Goudy Bookletter 1911",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Gowun-Batang": {
        "family": "Gowun Batang",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Gowun-Dodum": {
        "family": "Gowun Dodum",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Graduate": {
        "family": "Graduate",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Grand-Hotel": {
        "family": "Grand Hotel",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Grandiflora-One": {
        "family": "Grandiflora One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Grandstander": {
        "family": "Grandstander",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Grape-Nuts": {
        "family": "Grape Nuts",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Gravitas-One": {
        "family": "Gravitas One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Great-Vibes": {
        "family": "Great Vibes",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Grechen-Fuemen": {
        "family": "Grechen Fuemen",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Grenze": {
        "family": "Grenze",
        "category": "serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Grenze-Gotisch": {
        "family": "Grenze Gotisch",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Grey-Qo": {
        "family": "Grey Qo",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Griffy": {
        "family": "Griffy",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Gruppo": {
        "family": "Gruppo",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Gudea": {
        "family": "Gudea",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700"
        ]
    },
    "Gugi": {
        "family": "Gugi",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Gulzar": {
        "family": "Gulzar",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Gupter": {
        "family": "Gupter",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "700"
        ]
    },
    "Gurajada": {
        "family": "Gurajada",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Gwendolyn": {
        "family": "Gwendolyn",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Habibi": {
        "family": "Habibi",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Hachi-Maru-Pop": {
        "family": "Hachi Maru Pop",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Hahmlet": {
        "family": "Hahmlet",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Halant": {
        "family": "Halant",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Hammersmith-One": {
        "family": "Hammersmith One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Hanalei": {
        "family": "Hanalei",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Hanalei-Fill": {
        "family": "Hanalei Fill",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Handjet": {
        "family": "Handjet",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Handlee": {
        "family": "Handlee",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Hanken-Grotesk": {
        "family": "Hanken Grotesk",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Hanuman": {
        "family": "Hanuman",
        "category": "serif",
        "variants": [
            "100",
            "300",
            "regular",
            "700",
            "900"
        ]
    },
    "Happy-Monkey": {
        "family": "Happy Monkey",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Harmattan": {
        "family": "Harmattan",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Headland-One": {
        "family": "Headland One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Hedvig-Letters-Sans": {
        "family": "Hedvig Letters Sans",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Hedvig-Letters-Serif": {
        "family": "Hedvig Letters Serif",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Heebo": {
        "family": "Heebo",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Henny-Penny": {
        "family": "Henny Penny",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Hepta-Slab": {
        "family": "Hepta Slab",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Herr-Von-Muellerhoff": {
        "family": "Herr Von Muellerhoff",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Hi-Melody": {
        "family": "Hi Melody",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Hina-Mincho": {
        "family": "Hina Mincho",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Hind": {
        "family": "Hind",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Hind-Guntur": {
        "family": "Hind Guntur",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Hind-Madurai": {
        "family": "Hind Madurai",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Hind-Siliguri": {
        "family": "Hind Siliguri",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Hind-Vadodara": {
        "family": "Hind Vadodara",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Holtwood-One-SC": {
        "family": "Holtwood One SC",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Homemade-Apple": {
        "family": "Homemade Apple",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Homenaje": {
        "family": "Homenaje",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Honk": {
        "family": "Honk",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Hubballi": {
        "family": "Hubballi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Hurricane": {
        "family": "Hurricane",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "IBM-Plex-Mono": {
        "family": "IBM Plex Mono",
        "category": "monospace",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "IBM-Plex-Sans": {
        "family": "IBM Plex Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "IBM-Plex-Sans-Arabic": {
        "family": "IBM Plex Sans Arabic",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "IBM-Plex-Sans-Condensed": {
        "family": "IBM Plex Sans Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "IBM-Plex-Sans-Devanagari": {
        "family": "IBM Plex Sans Devanagari",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "IBM-Plex-Sans-Hebrew": {
        "family": "IBM Plex Sans Hebrew",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "IBM-Plex-Sans-JP": {
        "family": "IBM Plex Sans JP",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "IBM-Plex-Sans-KR": {
        "family": "IBM Plex Sans KR",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "IBM-Plex-Sans-Thai": {
        "family": "IBM Plex Sans Thai",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "IBM-Plex-Sans-Thai-Looped": {
        "family": "IBM Plex Sans Thai Looped",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "IBM-Plex-Serif": {
        "family": "IBM Plex Serif",
        "category": "serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "IM-Fell-DW-Pica": {
        "family": "IM Fell DW Pica",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "IM-Fell-DW-Pica-SC": {
        "family": "IM Fell DW Pica SC",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "IM-Fell-Double-Pica": {
        "family": "IM Fell Double Pica",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "IM-Fell-Double-Pica-SC": {
        "family": "IM Fell Double Pica SC",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "IM-Fell-English": {
        "family": "IM Fell English",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "IM-Fell-English-SC": {
        "family": "IM Fell English SC",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "IM-Fell-French-Canon": {
        "family": "IM Fell French Canon",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "IM-Fell-French-Canon-SC": {
        "family": "IM Fell French Canon SC",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "IM-Fell-Great-Primer": {
        "family": "IM Fell Great Primer",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "IM-Fell-Great-Primer-SC": {
        "family": "IM Fell Great Primer SC",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Ibarra-Real-Nova": {
        "family": "Ibarra Real Nova",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Iceberg": {
        "family": "Iceberg",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Iceland": {
        "family": "Iceland",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Imbue": {
        "family": "Imbue",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Imperial-Script": {
        "family": "Imperial Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Imprima": {
        "family": "Imprima",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Inclusive-Sans": {
        "family": "Inclusive Sans",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Inconsolata": {
        "family": "Inconsolata",
        "category": "monospace",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Inder": {
        "family": "Inder",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Indie-Flower": {
        "family": "Indie Flower",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ingrid-Darling": {
        "family": "Ingrid Darling",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Inika": {
        "family": "Inika",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Inknut-Antiqua": {
        "family": "Inknut Antiqua",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Inria-Sans": {
        "family": "Inria Sans",
        "category": "sans-serif",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Inria-Serif": {
        "family": "Inria Serif",
        "category": "serif",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Inspiration": {
        "family": "Inspiration",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Instrument-Sans": {
        "family": "Instrument Sans",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Instrument-Serif": {
        "family": "Instrument Serif",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Inter": {
        "family": "Inter",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Inter-Tight": {
        "family": "Inter Tight",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Irish-Grover": {
        "family": "Irish Grover",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Island-Moments": {
        "family": "Island Moments",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Istok-Web": {
        "family": "Istok Web",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Italiana": {
        "family": "Italiana",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Italianno": {
        "family": "Italianno",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Itim": {
        "family": "Itim",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Jacquarda-Bastarda-9": {
        "family": "Jacquarda Bastarda 9",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Jacques-Francois": {
        "family": "Jacques Francois",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Jacques-Francois-Shadow": {
        "family": "Jacques Francois Shadow",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Jaldi": {
        "family": "Jaldi",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "JetBrains-Mono": {
        "family": "JetBrains Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Jim-Nightshade": {
        "family": "Jim Nightshade",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Joan": {
        "family": "Joan",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Jockey-One": {
        "family": "Jockey One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Jolly-Lodger": {
        "family": "Jolly Lodger",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Jomhuria": {
        "family": "Jomhuria",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Jomolhari": {
        "family": "Jomolhari",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Josefin-Sans": {
        "family": "Josefin Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Josefin-Slab": {
        "family": "Josefin Slab",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Jost": {
        "family": "Jost",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Joti-One": {
        "family": "Joti One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Jua": {
        "family": "Jua",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Judson": {
        "family": "Judson",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700"
        ]
    },
    "Julee": {
        "family": "Julee",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Julius-Sans-One": {
        "family": "Julius Sans One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Junge": {
        "family": "Junge",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Jura": {
        "family": "Jura",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Just-Another-Hand": {
        "family": "Just Another Hand",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Just-Me-Again-Down-Here": {
        "family": "Just Me Again Down Here",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "K2D": {
        "family": "K2D",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic"
        ]
    },
    "Kablammo": {
        "family": "Kablammo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kadwa": {
        "family": "Kadwa",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Kaisei-Decol": {
        "family": "Kaisei Decol",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "700"
        ]
    },
    "Kaisei-HarunoUmi": {
        "family": "Kaisei HarunoUmi",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "700"
        ]
    },
    "Kaisei-Opti": {
        "family": "Kaisei Opti",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "700"
        ]
    },
    "Kaisei-Tokumin": {
        "family": "Kaisei Tokumin",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "700",
            "800"
        ]
    },
    "Kalam": {
        "family": "Kalam",
        "category": "handwriting",
        "variants": [
            "300",
            "regular",
            "700"
        ]
    },
    "Kalnia": {
        "family": "Kalnia",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Kameron": {
        "family": "Kameron",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Kanit": {
        "family": "Kanit",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Kantumruy-Pro": {
        "family": "Kantumruy Pro",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Karantina": {
        "family": "Karantina",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "700"
        ]
    },
    "Karla": {
        "family": "Karla",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Karma": {
        "family": "Karma",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Katibeh": {
        "family": "Katibeh",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kaushan-Script": {
        "family": "Kaushan Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Kavivanar": {
        "family": "Kavivanar",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Kavoon": {
        "family": "Kavoon",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kay-Pho-Du": {
        "family": "Kay Pho Du",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Kdam-Thmor-Pro": {
        "family": "Kdam Thmor Pro",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Keania-One": {
        "family": "Keania One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kelly-Slab": {
        "family": "Kelly Slab",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kenia": {
        "family": "Kenia",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Khand": {
        "family": "Khand",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Khmer": {
        "family": "Khmer",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Khula": {
        "family": "Khula",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "600",
            "700",
            "800"
        ]
    },
    "Kings": {
        "family": "Kings",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Kirang-Haerang": {
        "family": "Kirang Haerang",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kite-One": {
        "family": "Kite One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Kiwi-Maru": {
        "family": "Kiwi Maru",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500"
        ]
    },
    "Klee-One": {
        "family": "Klee One",
        "category": "handwriting",
        "variants": [
            "regular",
            "600"
        ]
    },
    "Knewave": {
        "family": "Knewave",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "KoHo": {
        "family": "KoHo",
        "category": "sans-serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Kodchasan": {
        "family": "Kodchasan",
        "category": "sans-serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Kode-Mono": {
        "family": "Kode Mono",
        "category": "monospace",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Koh-Santepheap": {
        "family": "Koh Santepheap",
        "category": "serif",
        "variants": [
            "100",
            "300",
            "regular",
            "700",
            "900"
        ]
    },
    "Kolker-Brush": {
        "family": "Kolker Brush",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Konkhmer-Sleokchher": {
        "family": "Konkhmer Sleokchher",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kosugi": {
        "family": "Kosugi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Kosugi-Maru": {
        "family": "Kosugi Maru",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Kotta-One": {
        "family": "Kotta One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Koulen": {
        "family": "Koulen",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kranky": {
        "family": "Kranky",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kreon": {
        "family": "Kreon",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Kristi": {
        "family": "Kristi",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Krona-One": {
        "family": "Krona One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Krub": {
        "family": "Krub",
        "category": "sans-serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Kufam": {
        "family": "Kufam",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Kulim-Park": {
        "family": "Kulim Park",
        "category": "sans-serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Kumar-One": {
        "family": "Kumar One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kumar-One-Outline": {
        "family": "Kumar One Outline",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Kumbh-Sans": {
        "family": "Kumbh Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Kurale": {
        "family": "Kurale",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "La-Belle-Aurore": {
        "family": "La Belle Aurore",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Labrada": {
        "family": "Labrada",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Lacquer": {
        "family": "Lacquer",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Laila": {
        "family": "Laila",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Lakki-Reddy": {
        "family": "Lakki Reddy",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Lalezar": {
        "family": "Lalezar",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Lancelot": {
        "family": "Lancelot",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Langar": {
        "family": "Langar",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Lateef": {
        "family": "Lateef",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Lato": {
        "family": "Lato",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic",
            "900",
            "900italic"
        ]
    },
    "Lavishly-Yours": {
        "family": "Lavishly Yours",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "League-Gothic": {
        "family": "League Gothic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "League-Script": {
        "family": "League Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "League-Spartan": {
        "family": "League Spartan",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Leckerli-One": {
        "family": "Leckerli One",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ledger": {
        "family": "Ledger",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Lekton": {
        "family": "Lekton",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700"
        ]
    },
    "Lemon": {
        "family": "Lemon",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Lemonada": {
        "family": "Lemonada",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Lexend": {
        "family": "Lexend",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Lexend-Deca": {
        "family": "Lexend Deca",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Lexend-Exa": {
        "family": "Lexend Exa",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Lexend-Giga": {
        "family": "Lexend Giga",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Lexend-Mega": {
        "family": "Lexend Mega",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Lexend-Peta": {
        "family": "Lexend Peta",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Lexend-Tera": {
        "family": "Lexend Tera",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Lexend-Zetta": {
        "family": "Lexend Zetta",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Libre-Barcode-128": {
        "family": "Libre Barcode 128",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Libre-Barcode-128-Text": {
        "family": "Libre Barcode 128 Text",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Libre-Barcode-39": {
        "family": "Libre Barcode 39",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Libre-Barcode-39-Extended": {
        "family": "Libre Barcode 39 Extended",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Libre-Barcode-39-Extended-Text": {
        "family": "Libre Barcode 39 Extended Text",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Libre-Barcode-39-Text": {
        "family": "Libre Barcode 39 Text",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Libre-Barcode-EAN13-Text": {
        "family": "Libre Barcode EAN13 Text",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Libre-Baskerville": {
        "family": "Libre Baskerville",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700"
        ]
    },
    "Libre-Bodoni": {
        "family": "Libre Bodoni",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Libre-Caslon-Display": {
        "family": "Libre Caslon Display",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Libre-Caslon-Text": {
        "family": "Libre Caslon Text",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700"
        ]
    },
    "Libre-Franklin": {
        "family": "Libre Franklin",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Licorice": {
        "family": "Licorice",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Life-Savers": {
        "family": "Life Savers",
        "category": "display",
        "variants": [
            "regular",
            "700",
            "800"
        ]
    },
    "Lilita-One": {
        "family": "Lilita One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Lily-Script-One": {
        "family": "Lily Script One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Limelight": {
        "family": "Limelight",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Linden-Hill": {
        "family": "Linden Hill",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Linefont": {
        "family": "Linefont",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Lisu-Bosa": {
        "family": "Lisu Bosa",
        "category": "serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Literata": {
        "family": "Literata",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Liu-Jian-Mao-Cao": {
        "family": "Liu Jian Mao Cao",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Livvic": {
        "family": "Livvic",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "900",
            "900italic"
        ]
    },
    "Lobster": {
        "family": "Lobster",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Lobster-Two": {
        "family": "Lobster Two",
        "category": "display",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Londrina-Outline": {
        "family": "Londrina Outline",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Londrina-Shadow": {
        "family": "Londrina Shadow",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Londrina-Sketch": {
        "family": "Londrina Sketch",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Londrina-Solid": {
        "family": "Londrina Solid",
        "category": "display",
        "variants": [
            "100",
            "300",
            "regular",
            "900"
        ]
    },
    "Long-Cang": {
        "family": "Long Cang",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Lora": {
        "family": "Lora",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Love-Light": {
        "family": "Love Light",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Love-Ya-Like-A-Sister": {
        "family": "Love Ya Like A Sister",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Loved-by-the-King": {
        "family": "Loved by the King",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Lovers-Quarrel": {
        "family": "Lovers Quarrel",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Luckiest-Guy": {
        "family": "Luckiest Guy",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Lugrasimo": {
        "family": "Lugrasimo",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Lumanosimo": {
        "family": "Lumanosimo",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Lunasima": {
        "family": "Lunasima",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Lusitana": {
        "family": "Lusitana",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Lustria": {
        "family": "Lustria",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Luxurious-Roman": {
        "family": "Luxurious Roman",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Luxurious-Script": {
        "family": "Luxurious Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "M-PLUS-1": {
        "family": "M PLUS 1",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "M-PLUS-1-Code": {
        "family": "M PLUS 1 Code",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "M-PLUS-1p": {
        "family": "M PLUS 1p",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "regular",
            "500",
            "700",
            "800",
            "900"
        ]
    },
    "M-PLUS-2": {
        "family": "M PLUS 2",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "M-PLUS-Code-Latin": {
        "family": "M PLUS Code Latin",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "M-PLUS-Rounded-1c": {
        "family": "M PLUS Rounded 1c",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "regular",
            "500",
            "700",
            "800",
            "900"
        ]
    },
    "Ma-Shan-Zheng": {
        "family": "Ma Shan Zheng",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Macondo": {
        "family": "Macondo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Macondo-Swash-Caps": {
        "family": "Macondo Swash Caps",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Mada": {
        "family": "Mada",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Magra": {
        "family": "Magra",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Maiden-Orange": {
        "family": "Maiden Orange",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Maitree": {
        "family": "Maitree",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Major-Mono-Display": {
        "family": "Major Mono Display",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Mako": {
        "family": "Mako",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Mali": {
        "family": "Mali",
        "category": "handwriting",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Mallanna": {
        "family": "Mallanna",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Mandali": {
        "family": "Mandali",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Manjari": {
        "family": "Manjari",
        "category": "sans-serif",
        "variants": [
            "100",
            "regular",
            "700"
        ]
    },
    "Manrope": {
        "family": "Manrope",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Mansalva": {
        "family": "Mansalva",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Manuale": {
        "family": "Manuale",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Marcellus": {
        "family": "Marcellus",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Marcellus-SC": {
        "family": "Marcellus SC",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Marck-Script": {
        "family": "Marck Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Margarine": {
        "family": "Margarine",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Marhey": {
        "family": "Marhey",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Markazi-Text": {
        "family": "Markazi Text",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Marko-One": {
        "family": "Marko One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Marmelad": {
        "family": "Marmelad",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Martel": {
        "family": "Martel",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Martel-Sans": {
        "family": "Martel Sans",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Martian-Mono": {
        "family": "Martian Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Marvel": {
        "family": "Marvel",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Mate": {
        "family": "Mate",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Mate-SC": {
        "family": "Mate SC",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Material-Icons": {
        "family": "Material Icons",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Material-Icons-Outlined": {
        "family": "Material Icons Outlined",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Material-Icons-Round": {
        "family": "Material Icons Round",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Material-Icons-Sharp": {
        "family": "Material Icons Sharp",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Material-Icons-Two-Tone": {
        "family": "Material Icons Two Tone",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Material-Symbols-Outlined": {
        "family": "Material Symbols Outlined",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Material-Symbols-Rounded": {
        "family": "Material Symbols Rounded",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Material-Symbols-Sharp": {
        "family": "Material Symbols Sharp",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Maven-Pro": {
        "family": "Maven Pro",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "McLaren": {
        "family": "McLaren",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Mea-Culpa": {
        "family": "Mea Culpa",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Meddon": {
        "family": "Meddon",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "MedievalSharp": {
        "family": "MedievalSharp",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Medula-One": {
        "family": "Medula One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Meera-Inimai": {
        "family": "Meera Inimai",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Megrim": {
        "family": "Megrim",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Meie-Script": {
        "family": "Meie Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Meow-Script": {
        "family": "Meow Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Merienda": {
        "family": "Merienda",
        "category": "handwriting",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Merriweather": {
        "family": "Merriweather",
        "category": "serif",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "700",
            "700italic",
            "900",
            "900italic"
        ]
    },
    "Merriweather-Sans": {
        "family": "Merriweather Sans",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Metal": {
        "family": "Metal",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Metal-Mania": {
        "family": "Metal Mania",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Metamorphous": {
        "family": "Metamorphous",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Metrophobic": {
        "family": "Metrophobic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Michroma": {
        "family": "Michroma",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Micro-5": {
        "family": "Micro 5",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Milonga": {
        "family": "Milonga",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Miltonian": {
        "family": "Miltonian",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Miltonian-Tattoo": {
        "family": "Miltonian Tattoo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Mina": {
        "family": "Mina",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Mingzat": {
        "family": "Mingzat",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Miniver": {
        "family": "Miniver",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Miriam-Libre": {
        "family": "Miriam Libre",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Mirza": {
        "family": "Mirza",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Miss-Fajardose": {
        "family": "Miss Fajardose",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Mitr": {
        "family": "Mitr",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Mochiy-Pop-One": {
        "family": "Mochiy Pop One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Mochiy-Pop-P-One": {
        "family": "Mochiy Pop P One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Modak": {
        "family": "Modak",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Modern-Antiqua": {
        "family": "Modern Antiqua",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Mogra": {
        "family": "Mogra",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Mohave": {
        "family": "Mohave",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Moirai-One": {
        "family": "Moirai One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Molengo": {
        "family": "Molengo",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Molle": {
        "family": "Molle",
        "category": "handwriting",
        "variants": [
            "italic"
        ]
    },
    "Monda": {
        "family": "Monda",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Monofett": {
        "family": "Monofett",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Monomaniac-One": {
        "family": "Monomaniac One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Monoton": {
        "family": "Monoton",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Monsieur-La-Doulaise": {
        "family": "Monsieur La Doulaise",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Montaga": {
        "family": "Montaga",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Montagu-Slab": {
        "family": "Montagu Slab",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "MonteCarlo": {
        "family": "MonteCarlo",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Montez": {
        "family": "Montez",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Montserrat": {
        "family": "Montserrat",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Montserrat-Alternates": {
        "family": "Montserrat Alternates",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Montserrat-Subrayada": {
        "family": "Montserrat Subrayada",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Moo-Lah-Lah": {
        "family": "Moo Lah Lah",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Mooli": {
        "family": "Mooli",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Moon-Dance": {
        "family": "Moon Dance",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Moul": {
        "family": "Moul",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Moulpali": {
        "family": "Moulpali",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Mountains-of-Christmas": {
        "family": "Mountains of Christmas",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Mouse-Memoirs": {
        "family": "Mouse Memoirs",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Mr-Bedfort": {
        "family": "Mr Bedfort",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Mr-Dafoe": {
        "family": "Mr Dafoe",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Mr-De-Haviland": {
        "family": "Mr De Haviland",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Mrs-Saint-Delafield": {
        "family": "Mrs Saint Delafield",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Mrs-Sheppards": {
        "family": "Mrs Sheppards",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ms-Madi": {
        "family": "Ms Madi",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Mukta": {
        "family": "Mukta",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Mukta-Mahee": {
        "family": "Mukta Mahee",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Mukta-Malar": {
        "family": "Mukta Malar",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Mukta-Vaani": {
        "family": "Mukta Vaani",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Mulish": {
        "family": "Mulish",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Murecho": {
        "family": "Murecho",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "MuseoModerno": {
        "family": "MuseoModerno",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "My-Soul": {
        "family": "My Soul",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Mynerve": {
        "family": "Mynerve",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Mystery-Quest": {
        "family": "Mystery Quest",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "NTR": {
        "family": "NTR",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Nabla": {
        "family": "Nabla",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Namdhinggo": {
        "family": "Namdhinggo",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Nanum-Brush-Script": {
        "family": "Nanum Brush Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Nanum-Gothic": {
        "family": "Nanum Gothic",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700",
            "800"
        ]
    },
    "Nanum-Gothic-Coding": {
        "family": "Nanum Gothic Coding",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Nanum-Myeongjo": {
        "family": "Nanum Myeongjo",
        "category": "serif",
        "variants": [
            "regular",
            "700",
            "800"
        ]
    },
    "Nanum-Pen-Script": {
        "family": "Nanum Pen Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Narnoor": {
        "family": "Narnoor",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Neonderthaw": {
        "family": "Neonderthaw",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Nerko-One": {
        "family": "Nerko One",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Neucha": {
        "family": "Neucha",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Neuton": {
        "family": "Neuton",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "italic",
            "700",
            "800"
        ]
    },
    "New-Rocker": {
        "family": "New Rocker",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "New-Tegomin": {
        "family": "New Tegomin",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "News-Cycle": {
        "family": "News Cycle",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Newsreader": {
        "family": "Newsreader",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Niconne": {
        "family": "Niconne",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Niramit": {
        "family": "Niramit",
        "category": "sans-serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Nixie-One": {
        "family": "Nixie One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Nobile": {
        "family": "Nobile",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "500",
            "500italic",
            "700",
            "700italic"
        ]
    },
    "Nokora": {
        "family": "Nokora",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "regular",
            "700",
            "900"
        ]
    },
    "Norican": {
        "family": "Norican",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Nosifer": {
        "family": "Nosifer",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Notable": {
        "family": "Notable",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Nothing-You-Could-Do": {
        "family": "Nothing You Could Do",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Noticia-Text": {
        "family": "Noticia Text",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Noto-Color-Emoji": {
        "family": "Noto Color Emoji",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Emoji": {
        "family": "Noto Emoji",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Kufi-Arabic": {
        "family": "Noto Kufi Arabic",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Music": {
        "family": "Noto Music",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Naskh-Arabic": {
        "family": "Noto Naskh Arabic",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Nastaliq-Urdu": {
        "family": "Noto Nastaliq Urdu",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Rashi-Hebrew": {
        "family": "Noto Rashi Hebrew",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans": {
        "family": "Noto Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Noto-Sans-Adlam": {
        "family": "Noto Sans Adlam",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Adlam-Unjoined": {
        "family": "Noto Sans Adlam Unjoined",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Anatolian-Hieroglyphs": {
        "family": "Noto Sans Anatolian Hieroglyphs",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Arabic": {
        "family": "Noto Sans Arabic",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Armenian": {
        "family": "Noto Sans Armenian",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Avestan": {
        "family": "Noto Sans Avestan",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Balinese": {
        "family": "Noto Sans Balinese",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Bamum": {
        "family": "Noto Sans Bamum",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Bassa-Vah": {
        "family": "Noto Sans Bassa Vah",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Batak": {
        "family": "Noto Sans Batak",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Bengali": {
        "family": "Noto Sans Bengali",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Bhaiksuki": {
        "family": "Noto Sans Bhaiksuki",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Brahmi": {
        "family": "Noto Sans Brahmi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Buginese": {
        "family": "Noto Sans Buginese",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Buhid": {
        "family": "Noto Sans Buhid",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Canadian-Aboriginal": {
        "family": "Noto Sans Canadian Aboriginal",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Carian": {
        "family": "Noto Sans Carian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Caucasian-Albanian": {
        "family": "Noto Sans Caucasian Albanian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Chakma": {
        "family": "Noto Sans Chakma",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Cham": {
        "family": "Noto Sans Cham",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Cherokee": {
        "family": "Noto Sans Cherokee",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Chorasmian": {
        "family": "Noto Sans Chorasmian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Coptic": {
        "family": "Noto Sans Coptic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Cuneiform": {
        "family": "Noto Sans Cuneiform",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Cypriot": {
        "family": "Noto Sans Cypriot",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Cypro-Minoan": {
        "family": "Noto Sans Cypro Minoan",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Deseret": {
        "family": "Noto Sans Deseret",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Devanagari": {
        "family": "Noto Sans Devanagari",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Display": {
        "family": "Noto Sans Display",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Noto-Sans-Duployan": {
        "family": "Noto Sans Duployan",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Noto-Sans-Egyptian-Hieroglyphs": {
        "family": "Noto Sans Egyptian Hieroglyphs",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Elbasan": {
        "family": "Noto Sans Elbasan",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Elymaic": {
        "family": "Noto Sans Elymaic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Ethiopic": {
        "family": "Noto Sans Ethiopic",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Georgian": {
        "family": "Noto Sans Georgian",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Glagolitic": {
        "family": "Noto Sans Glagolitic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Gothic": {
        "family": "Noto Sans Gothic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Grantha": {
        "family": "Noto Sans Grantha",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Gujarati": {
        "family": "Noto Sans Gujarati",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Gunjala-Gondi": {
        "family": "Noto Sans Gunjala Gondi",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Gurmukhi": {
        "family": "Noto Sans Gurmukhi",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-HK": {
        "family": "Noto Sans HK",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Hanifi-Rohingya": {
        "family": "Noto Sans Hanifi Rohingya",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Hanunoo": {
        "family": "Noto Sans Hanunoo",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Hatran": {
        "family": "Noto Sans Hatran",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Hebrew": {
        "family": "Noto Sans Hebrew",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Imperial-Aramaic": {
        "family": "Noto Sans Imperial Aramaic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Indic-Siyaq-Numbers": {
        "family": "Noto Sans Indic Siyaq Numbers",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Inscriptional-Pahlavi": {
        "family": "Noto Sans Inscriptional Pahlavi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Inscriptional-Parthian": {
        "family": "Noto Sans Inscriptional Parthian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-JP": {
        "family": "Noto Sans JP",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Javanese": {
        "family": "Noto Sans Javanese",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-KR": {
        "family": "Noto Sans KR",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Kaithi": {
        "family": "Noto Sans Kaithi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Kannada": {
        "family": "Noto Sans Kannada",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Kawi": {
        "family": "Noto Sans Kawi",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Kayah-Li": {
        "family": "Noto Sans Kayah Li",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Kharoshthi": {
        "family": "Noto Sans Kharoshthi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Khmer": {
        "family": "Noto Sans Khmer",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Khojki": {
        "family": "Noto Sans Khojki",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Khudawadi": {
        "family": "Noto Sans Khudawadi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Lao": {
        "family": "Noto Sans Lao",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Lao-Looped": {
        "family": "Noto Sans Lao Looped",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Lepcha": {
        "family": "Noto Sans Lepcha",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Limbu": {
        "family": "Noto Sans Limbu",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Linear-A": {
        "family": "Noto Sans Linear A",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Linear-B": {
        "family": "Noto Sans Linear B",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Lisu": {
        "family": "Noto Sans Lisu",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Lycian": {
        "family": "Noto Sans Lycian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Lydian": {
        "family": "Noto Sans Lydian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Mahajani": {
        "family": "Noto Sans Mahajani",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Malayalam": {
        "family": "Noto Sans Malayalam",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Mandaic": {
        "family": "Noto Sans Mandaic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Manichaean": {
        "family": "Noto Sans Manichaean",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Marchen": {
        "family": "Noto Sans Marchen",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Masaram-Gondi": {
        "family": "Noto Sans Masaram Gondi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Math": {
        "family": "Noto Sans Math",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Mayan-Numerals": {
        "family": "Noto Sans Mayan Numerals",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Medefaidrin": {
        "family": "Noto Sans Medefaidrin",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Meetei-Mayek": {
        "family": "Noto Sans Meetei Mayek",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Mende-Kikakui": {
        "family": "Noto Sans Mende Kikakui",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Meroitic": {
        "family": "Noto Sans Meroitic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Miao": {
        "family": "Noto Sans Miao",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Modi": {
        "family": "Noto Sans Modi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Mongolian": {
        "family": "Noto Sans Mongolian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Mono": {
        "family": "Noto Sans Mono",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Mro": {
        "family": "Noto Sans Mro",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Multani": {
        "family": "Noto Sans Multani",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Myanmar": {
        "family": "Noto Sans Myanmar",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-NKo": {
        "family": "Noto Sans NKo",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-NKo-Unjoined": {
        "family": "Noto Sans NKo Unjoined",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Nabataean": {
        "family": "Noto Sans Nabataean",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Nag-Mundari": {
        "family": "Noto Sans Nag Mundari",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Nandinagari": {
        "family": "Noto Sans Nandinagari",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-New-Tai-Lue": {
        "family": "Noto Sans New Tai Lue",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Newa": {
        "family": "Noto Sans Newa",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Nushu": {
        "family": "Noto Sans Nushu",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Ogham": {
        "family": "Noto Sans Ogham",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Ol-Chiki": {
        "family": "Noto Sans Ol Chiki",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Old-Hungarian": {
        "family": "Noto Sans Old Hungarian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Old-Italic": {
        "family": "Noto Sans Old Italic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Old-North-Arabian": {
        "family": "Noto Sans Old North Arabian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Old-Permic": {
        "family": "Noto Sans Old Permic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Old-Persian": {
        "family": "Noto Sans Old Persian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Old-Sogdian": {
        "family": "Noto Sans Old Sogdian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Old-South-Arabian": {
        "family": "Noto Sans Old South Arabian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Old-Turkic": {
        "family": "Noto Sans Old Turkic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Oriya": {
        "family": "Noto Sans Oriya",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Osage": {
        "family": "Noto Sans Osage",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Osmanya": {
        "family": "Noto Sans Osmanya",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Pahawh-Hmong": {
        "family": "Noto Sans Pahawh Hmong",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Palmyrene": {
        "family": "Noto Sans Palmyrene",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Pau-Cin-Hau": {
        "family": "Noto Sans Pau Cin Hau",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Phags-Pa": {
        "family": "Noto Sans Phags Pa",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Phoenician": {
        "family": "Noto Sans Phoenician",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Psalter-Pahlavi": {
        "family": "Noto Sans Psalter Pahlavi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Rejang": {
        "family": "Noto Sans Rejang",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Runic": {
        "family": "Noto Sans Runic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-SC": {
        "family": "Noto Sans SC",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Samaritan": {
        "family": "Noto Sans Samaritan",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Saurashtra": {
        "family": "Noto Sans Saurashtra",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Sharada": {
        "family": "Noto Sans Sharada",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Shavian": {
        "family": "Noto Sans Shavian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Siddham": {
        "family": "Noto Sans Siddham",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-SignWriting": {
        "family": "Noto Sans SignWriting",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Sinhala": {
        "family": "Noto Sans Sinhala",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Sogdian": {
        "family": "Noto Sans Sogdian",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Sora-Sompeng": {
        "family": "Noto Sans Sora Sompeng",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Soyombo": {
        "family": "Noto Sans Soyombo",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Sundanese": {
        "family": "Noto Sans Sundanese",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Syloti-Nagri": {
        "family": "Noto Sans Syloti Nagri",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Symbols": {
        "family": "Noto Sans Symbols",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Symbols-2": {
        "family": "Noto Sans Symbols 2",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Syriac": {
        "family": "Noto Sans Syriac",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Syriac-Eastern": {
        "family": "Noto Sans Syriac Eastern",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-TC": {
        "family": "Noto Sans TC",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Tagalog": {
        "family": "Noto Sans Tagalog",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Tagbanwa": {
        "family": "Noto Sans Tagbanwa",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Tai-Le": {
        "family": "Noto Sans Tai Le",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Tai-Tham": {
        "family": "Noto Sans Tai Tham",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Tai-Viet": {
        "family": "Noto Sans Tai Viet",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Takri": {
        "family": "Noto Sans Takri",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Tamil": {
        "family": "Noto Sans Tamil",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Tamil-Supplement": {
        "family": "Noto Sans Tamil Supplement",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Tangsa": {
        "family": "Noto Sans Tangsa",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Telugu": {
        "family": "Noto Sans Telugu",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Thaana": {
        "family": "Noto Sans Thaana",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Thai": {
        "family": "Noto Sans Thai",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Thai-Looped": {
        "family": "Noto Sans Thai Looped",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Sans-Tifinagh": {
        "family": "Noto Sans Tifinagh",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Tirhuta": {
        "family": "Noto Sans Tirhuta",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Ugaritic": {
        "family": "Noto Sans Ugaritic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Vai": {
        "family": "Noto Sans Vai",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Vithkuqi": {
        "family": "Noto Sans Vithkuqi",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Sans-Wancho": {
        "family": "Noto Sans Wancho",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Warang-Citi": {
        "family": "Noto Sans Warang Citi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Yi": {
        "family": "Noto Sans Yi",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Sans-Zanabazar-Square": {
        "family": "Noto Sans Zanabazar Square",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif": {
        "family": "Noto Serif",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Noto-Serif-Ahom": {
        "family": "Noto Serif Ahom",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif-Armenian": {
        "family": "Noto Serif Armenian",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Balinese": {
        "family": "Noto Serif Balinese",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif-Bengali": {
        "family": "Noto Serif Bengali",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Devanagari": {
        "family": "Noto Serif Devanagari",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Display": {
        "family": "Noto Serif Display",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Noto-Serif-Dogra": {
        "family": "Noto Serif Dogra",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif-Ethiopic": {
        "family": "Noto Serif Ethiopic",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Georgian": {
        "family": "Noto Serif Georgian",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Grantha": {
        "family": "Noto Serif Grantha",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif-Gujarati": {
        "family": "Noto Serif Gujarati",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Gurmukhi": {
        "family": "Noto Serif Gurmukhi",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-HK": {
        "family": "Noto Serif HK",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Hebrew": {
        "family": "Noto Serif Hebrew",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-JP": {
        "family": "Noto Serif JP",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "900"
        ]
    },
    "Noto-Serif-KR": {
        "family": "Noto Serif KR",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "900"
        ]
    },
    "Noto-Serif-Kannada": {
        "family": "Noto Serif Kannada",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Khitan-Small-Script": {
        "family": "Noto Serif Khitan Small Script",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif-Khmer": {
        "family": "Noto Serif Khmer",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Khojki": {
        "family": "Noto Serif Khojki",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Serif-Lao": {
        "family": "Noto Serif Lao",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Makasar": {
        "family": "Noto Serif Makasar",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif-Malayalam": {
        "family": "Noto Serif Malayalam",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Myanmar": {
        "family": "Noto Serif Myanmar",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-NP-Hmong": {
        "family": "Noto Serif NP Hmong",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Serif-Old-Uyghur": {
        "family": "Noto Serif Old Uyghur",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif-Oriya": {
        "family": "Noto Serif Oriya",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Serif-Ottoman-Siyaq": {
        "family": "Noto Serif Ottoman Siyaq",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif-SC": {
        "family": "Noto Serif SC",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "900"
        ]
    },
    "Noto-Serif-Sinhala": {
        "family": "Noto Serif Sinhala",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-TC": {
        "family": "Noto Serif TC",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "900"
        ]
    },
    "Noto-Serif-Tamil": {
        "family": "Noto Serif Tamil",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Noto-Serif-Tangut": {
        "family": "Noto Serif Tangut",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Noto-Serif-Telugu": {
        "family": "Noto Serif Telugu",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Thai": {
        "family": "Noto Serif Thai",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Tibetan": {
        "family": "Noto Serif Tibetan",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Noto-Serif-Toto": {
        "family": "Noto Serif Toto",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Serif-Vithkuqi": {
        "family": "Noto Serif Vithkuqi",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Serif-Yezidi": {
        "family": "Noto Serif Yezidi",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Noto-Traditional-Nushu": {
        "family": "Noto Traditional Nushu",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Nova-Cut": {
        "family": "Nova Cut",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Nova-Flat": {
        "family": "Nova Flat",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Nova-Mono": {
        "family": "Nova Mono",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Nova-Oval": {
        "family": "Nova Oval",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Nova-Round": {
        "family": "Nova Round",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Nova-Script": {
        "family": "Nova Script",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Nova-Slim": {
        "family": "Nova Slim",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Nova-Square": {
        "family": "Nova Square",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Numans": {
        "family": "Numans",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Nunito": {
        "family": "Nunito",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Nunito-Sans": {
        "family": "Nunito Sans",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Nuosu-SIL": {
        "family": "Nuosu SIL",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Odibee-Sans": {
        "family": "Odibee Sans",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Odor-Mean-Chey": {
        "family": "Odor Mean Chey",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Offside": {
        "family": "Offside",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Oi": {
        "family": "Oi",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Old-Standard-TT": {
        "family": "Old Standard TT",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700"
        ]
    },
    "Oldenburg": {
        "family": "Oldenburg",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Ole": {
        "family": "Ole",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Oleo-Script": {
        "family": "Oleo Script",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Oleo-Script-Swash-Caps": {
        "family": "Oleo Script Swash Caps",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Onest": {
        "family": "Onest",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Oooh-Baby": {
        "family": "Oooh Baby",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Open-Sans": {
        "family": "Open Sans",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Oranienbaum": {
        "family": "Oranienbaum",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Orbit": {
        "family": "Orbit",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Orbitron": {
        "family": "Orbitron",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Oregano": {
        "family": "Oregano",
        "category": "display",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Orelega-One": {
        "family": "Orelega One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Orienta": {
        "family": "Orienta",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Original-Surfer": {
        "family": "Original Surfer",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Oswald": {
        "family": "Oswald",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Outfit": {
        "family": "Outfit",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Over-the-Rainbow": {
        "family": "Over the Rainbow",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Overlock": {
        "family": "Overlock",
        "category": "display",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic",
            "900",
            "900italic"
        ]
    },
    "Overlock-SC": {
        "family": "Overlock SC",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Overpass": {
        "family": "Overpass",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Overpass-Mono": {
        "family": "Overpass Mono",
        "category": "monospace",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Ovo": {
        "family": "Ovo",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Oxanium": {
        "family": "Oxanium",
        "category": "display",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Oxygen": {
        "family": "Oxygen",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "700"
        ]
    },
    "Oxygen-Mono": {
        "family": "Oxygen Mono",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "PT-Mono": {
        "family": "PT Mono",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "PT-Sans": {
        "family": "PT Sans",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "PT-Sans-Caption": {
        "family": "PT Sans Caption",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "PT-Sans-Narrow": {
        "family": "PT Sans Narrow",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "PT-Serif": {
        "family": "PT Serif",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "PT-Serif-Caption": {
        "family": "PT Serif Caption",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Pacifico": {
        "family": "Pacifico",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Padauk": {
        "family": "Padauk",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Padyakke-Expanded-One": {
        "family": "Padyakke Expanded One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Palanquin": {
        "family": "Palanquin",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Palanquin-Dark": {
        "family": "Palanquin Dark",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Palette-Mosaic": {
        "family": "Palette Mosaic",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Pangolin": {
        "family": "Pangolin",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Paprika": {
        "family": "Paprika",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Parisienne": {
        "family": "Parisienne",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Passero-One": {
        "family": "Passero One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Passion-One": {
        "family": "Passion One",
        "category": "display",
        "variants": [
            "regular",
            "700",
            "900"
        ]
    },
    "Passions-Conflict": {
        "family": "Passions Conflict",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Pathway-Extreme": {
        "family": "Pathway Extreme",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Pathway-Gothic-One": {
        "family": "Pathway Gothic One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Patrick-Hand": {
        "family": "Patrick Hand",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Patrick-Hand-SC": {
        "family": "Patrick Hand SC",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Pattaya": {
        "family": "Pattaya",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Patua-One": {
        "family": "Patua One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Pavanam": {
        "family": "Pavanam",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Paytone-One": {
        "family": "Paytone One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Peddana": {
        "family": "Peddana",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Peralta": {
        "family": "Peralta",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Permanent-Marker": {
        "family": "Permanent Marker",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Petemoss": {
        "family": "Petemoss",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Petit-Formal-Script": {
        "family": "Petit Formal Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Petrona": {
        "family": "Petrona",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Philosopher": {
        "family": "Philosopher",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Phudu": {
        "family": "Phudu",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Piazzolla": {
        "family": "Piazzolla",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Piedra": {
        "family": "Piedra",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Pinyon-Script": {
        "family": "Pinyon Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Pirata-One": {
        "family": "Pirata One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Pixelify-Sans": {
        "family": "Pixelify Sans",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Plaster": {
        "family": "Plaster",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Play": {
        "family": "Play",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Playball": {
        "family": "Playball",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Playfair": {
        "family": "Playfair",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Playfair-Display": {
        "family": "Playfair Display",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Playfair-Display-SC": {
        "family": "Playfair Display SC",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic",
            "900",
            "900italic"
        ]
    },
    "Playpen-Sans": {
        "family": "Playpen Sans",
        "category": "handwriting",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Plus-Jakarta-Sans": {
        "family": "Plus Jakarta Sans",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Podkova": {
        "family": "Podkova",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Poiret-One": {
        "family": "Poiret One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Poller-One": {
        "family": "Poller One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Poltawski-Nowy": {
        "family": "Poltawski Nowy",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Poly": {
        "family": "Poly",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Pompiere": {
        "family": "Pompiere",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Pontano-Sans": {
        "family": "Pontano Sans",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Poor-Story": {
        "family": "Poor Story",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Poppins": {
        "family": "Poppins",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Port-Lligat-Sans": {
        "family": "Port Lligat Sans",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Port-Lligat-Slab": {
        "family": "Port Lligat Slab",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Potta-One": {
        "family": "Potta One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Pragati-Narrow": {
        "family": "Pragati Narrow",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Praise": {
        "family": "Praise",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Prata": {
        "family": "Prata",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Preahvihear": {
        "family": "Preahvihear",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Press-Start-2P": {
        "family": "Press Start 2P",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Pridi": {
        "family": "Pridi",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Princess-Sofia": {
        "family": "Princess Sofia",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Prociono": {
        "family": "Prociono",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Prompt": {
        "family": "Prompt",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Prosto-One": {
        "family": "Prosto One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Protest-Guerrilla": {
        "family": "Protest Guerrilla",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Protest-Revolution": {
        "family": "Protest Revolution",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Protest-Riot": {
        "family": "Protest Riot",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Protest-Strike": {
        "family": "Protest Strike",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Proza-Libre": {
        "family": "Proza Libre",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic"
        ]
    },
    "Public-Sans": {
        "family": "Public Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Puppies-Play": {
        "family": "Puppies Play",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Puritan": {
        "family": "Puritan",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Purple-Purse": {
        "family": "Purple Purse",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Qahiri": {
        "family": "Qahiri",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Quando": {
        "family": "Quando",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Quantico": {
        "family": "Quantico",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Quattrocento": {
        "family": "Quattrocento",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Quattrocento-Sans": {
        "family": "Quattrocento Sans",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Questrial": {
        "family": "Questrial",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Quicksand": {
        "family": "Quicksand",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Quintessential": {
        "family": "Quintessential",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Qwigley": {
        "family": "Qwigley",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Qwitcher-Grypen": {
        "family": "Qwitcher Grypen",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "REM": {
        "family": "REM",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Racing-Sans-One": {
        "family": "Racing Sans One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Radio-Canada": {
        "family": "Radio Canada",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Radley": {
        "family": "Radley",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Rajdhani": {
        "family": "Rajdhani",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Rakkas": {
        "family": "Rakkas",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Raleway": {
        "family": "Raleway",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Raleway-Dots": {
        "family": "Raleway Dots",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Ramabhadra": {
        "family": "Ramabhadra",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Ramaraja": {
        "family": "Ramaraja",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Rambla": {
        "family": "Rambla",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Rammetto-One": {
        "family": "Rammetto One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rampart-One": {
        "family": "Rampart One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Ranchers": {
        "family": "Ranchers",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rancho": {
        "family": "Rancho",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ranga": {
        "family": "Ranga",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Rasa": {
        "family": "Rasa",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Rationale": {
        "family": "Rationale",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Ravi-Prakash": {
        "family": "Ravi Prakash",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Readex-Pro": {
        "family": "Readex Pro",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Recursive": {
        "family": "Recursive",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Red-Hat-Display": {
        "family": "Red Hat Display",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Red-Hat-Mono": {
        "family": "Red Hat Mono",
        "category": "monospace",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Red-Hat-Text": {
        "family": "Red Hat Text",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Red-Rose": {
        "family": "Red Rose",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Redacted": {
        "family": "Redacted",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Redacted-Script": {
        "family": "Redacted Script",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "700"
        ]
    },
    "Redressed": {
        "family": "Redressed",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Reem-Kufi": {
        "family": "Reem Kufi",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Reem-Kufi-Fun": {
        "family": "Reem Kufi Fun",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Reem-Kufi-Ink": {
        "family": "Reem Kufi Ink",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Reenie-Beanie": {
        "family": "Reenie Beanie",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Reggae-One": {
        "family": "Reggae One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rethink-Sans": {
        "family": "Rethink Sans",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Revalia": {
        "family": "Revalia",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rhodium-Libre": {
        "family": "Rhodium Libre",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Ribeye": {
        "family": "Ribeye",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Ribeye-Marrow": {
        "family": "Ribeye Marrow",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Righteous": {
        "family": "Righteous",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Risque": {
        "family": "Risque",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Road-Rage": {
        "family": "Road Rage",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Roboto": {
        "family": "Roboto",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "700",
            "700italic",
            "900",
            "900italic"
        ]
    },
    "Roboto-Condensed": {
        "family": "Roboto Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Roboto-Flex": {
        "family": "Roboto Flex",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Roboto-Mono": {
        "family": "Roboto Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Roboto-Serif": {
        "family": "Roboto Serif",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Roboto-Slab": {
        "family": "Roboto Slab",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Rochester": {
        "family": "Rochester",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Rock-3D": {
        "family": "Rock 3D",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rock-Salt": {
        "family": "Rock Salt",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "RocknRoll-One": {
        "family": "RocknRoll One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Rokkitt": {
        "family": "Rokkitt",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Romanesco": {
        "family": "Romanesco",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ropa-Sans": {
        "family": "Ropa Sans",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Rosario": {
        "family": "Rosario",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Rosarivo": {
        "family": "Rosarivo",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Rouge-Script": {
        "family": "Rouge Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Rowdies": {
        "family": "Rowdies",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "700"
        ]
    },
    "Rozha-One": {
        "family": "Rozha One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Rubik": {
        "family": "Rubik",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Rubik-80s-Fade": {
        "family": "Rubik 80s Fade",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Beastly": {
        "family": "Rubik Beastly",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Broken-Fax": {
        "family": "Rubik Broken Fax",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Bubbles": {
        "family": "Rubik Bubbles",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Burned": {
        "family": "Rubik Burned",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Dirt": {
        "family": "Rubik Dirt",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Distressed": {
        "family": "Rubik Distressed",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Doodle-Shadow": {
        "family": "Rubik Doodle Shadow",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Doodle-Triangles": {
        "family": "Rubik Doodle Triangles",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Gemstones": {
        "family": "Rubik Gemstones",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Glitch": {
        "family": "Rubik Glitch",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Glitch-Pop": {
        "family": "Rubik Glitch Pop",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Iso": {
        "family": "Rubik Iso",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Lines": {
        "family": "Rubik Lines",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Maps": {
        "family": "Rubik Maps",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Marker-Hatch": {
        "family": "Rubik Marker Hatch",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Maze": {
        "family": "Rubik Maze",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Microbe": {
        "family": "Rubik Microbe",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Mono-One": {
        "family": "Rubik Mono One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Moonrocks": {
        "family": "Rubik Moonrocks",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Pixels": {
        "family": "Rubik Pixels",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Puddles": {
        "family": "Rubik Puddles",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Scribble": {
        "family": "Rubik Scribble",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Spray-Paint": {
        "family": "Rubik Spray Paint",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Storm": {
        "family": "Rubik Storm",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Vinyl": {
        "family": "Rubik Vinyl",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Rubik-Wet-Paint": {
        "family": "Rubik Wet Paint",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Ruda": {
        "family": "Ruda",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Rufina": {
        "family": "Rufina",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Ruge-Boogie": {
        "family": "Ruge Boogie",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ruluko": {
        "family": "Ruluko",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Rum-Raisin": {
        "family": "Rum Raisin",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Ruslan-Display": {
        "family": "Ruslan Display",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Russo-One": {
        "family": "Russo One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Ruthie": {
        "family": "Ruthie",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ruwudu": {
        "family": "Ruwudu",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Rye": {
        "family": "Rye",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "STIX-Two-Text": {
        "family": "STIX Two Text",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Sacramento": {
        "family": "Sacramento",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Sahitya": {
        "family": "Sahitya",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Sail": {
        "family": "Sail",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Saira": {
        "family": "Saira",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Saira-Condensed": {
        "family": "Saira Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Saira-Extra-Condensed": {
        "family": "Saira Extra Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Saira-Semi-Condensed": {
        "family": "Saira Semi Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Saira-Stencil-One": {
        "family": "Saira Stencil One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Salsa": {
        "family": "Salsa",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sanchez": {
        "family": "Sanchez",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Sancreek": {
        "family": "Sancreek",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sansita": {
        "family": "Sansita",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Sansita-Swashed": {
        "family": "Sansita Swashed",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Sarabun": {
        "family": "Sarabun",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic"
        ]
    },
    "Sarala": {
        "family": "Sarala",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Sarina": {
        "family": "Sarina",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sarpanch": {
        "family": "Sarpanch",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Sassy-Frass": {
        "family": "Sassy Frass",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Satisfy": {
        "family": "Satisfy",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Sawarabi-Gothic": {
        "family": "Sawarabi Gothic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Sawarabi-Mincho": {
        "family": "Sawarabi Mincho",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Scada": {
        "family": "Scada",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Scheherazade-New": {
        "family": "Scheherazade New",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Schibsted-Grotesk": {
        "family": "Schibsted Grotesk",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Schoolbell": {
        "family": "Schoolbell",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Scope-One": {
        "family": "Scope One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Seaweed-Script": {
        "family": "Seaweed Script",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Secular-One": {
        "family": "Secular One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Sedgwick-Ave": {
        "family": "Sedgwick Ave",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Sedgwick-Ave-Display": {
        "family": "Sedgwick Ave Display",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Sen": {
        "family": "Sen",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Send-Flowers": {
        "family": "Send Flowers",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Sevillana": {
        "family": "Sevillana",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Seymour-One": {
        "family": "Seymour One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Shadows-Into-Light": {
        "family": "Shadows Into Light",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Shadows-Into-Light-Two": {
        "family": "Shadows Into Light Two",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Shalimar": {
        "family": "Shalimar",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Shantell-Sans": {
        "family": "Shantell Sans",
        "category": "display",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic"
        ]
    },
    "Shanti": {
        "family": "Shanti",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Share": {
        "family": "Share",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Share-Tech": {
        "family": "Share Tech",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Share-Tech-Mono": {
        "family": "Share Tech Mono",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Shippori-Antique": {
        "family": "Shippori Antique",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Shippori-Antique-B1": {
        "family": "Shippori Antique B1",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Shippori-Mincho": {
        "family": "Shippori Mincho",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Shippori-Mincho-B1": {
        "family": "Shippori Mincho B1",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Shizuru": {
        "family": "Shizuru",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Shojumaru": {
        "family": "Shojumaru",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Short-Stack": {
        "family": "Short Stack",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Shrikhand": {
        "family": "Shrikhand",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Siemreap": {
        "family": "Siemreap",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Sigmar": {
        "family": "Sigmar",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sigmar-One": {
        "family": "Sigmar One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Signika": {
        "family": "Signika",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Signika-Negative": {
        "family": "Signika Negative",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Silkscreen": {
        "family": "Silkscreen",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Simonetta": {
        "family": "Simonetta",
        "category": "display",
        "variants": [
            "regular",
            "italic",
            "900",
            "900italic"
        ]
    },
    "Single-Day": {
        "family": "Single Day",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sintony": {
        "family": "Sintony",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Sirin-Stencil": {
        "family": "Sirin Stencil",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Six-Caps": {
        "family": "Six Caps",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Sixtyfour": {
        "family": "Sixtyfour",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Skranji": {
        "family": "Skranji",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Slabo-13px": {
        "family": "Slabo 13px",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Slabo-27px": {
        "family": "Slabo 27px",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Slackey": {
        "family": "Slackey",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Slackside-One": {
        "family": "Slackside One",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Smokum": {
        "family": "Smokum",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Smooch": {
        "family": "Smooch",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Smooch-Sans": {
        "family": "Smooch Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Smythe": {
        "family": "Smythe",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sniglet": {
        "family": "Sniglet",
        "category": "display",
        "variants": [
            "regular",
            "800"
        ]
    },
    "Snippet": {
        "family": "Snippet",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Snowburst-One": {
        "family": "Snowburst One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sofadi-One": {
        "family": "Sofadi One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sofia": {
        "family": "Sofia",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Sofia-Sans": {
        "family": "Sofia Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Sofia-Sans-Condensed": {
        "family": "Sofia Sans Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Sofia-Sans-Extra-Condensed": {
        "family": "Sofia Sans Extra Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Sofia-Sans-Semi-Condensed": {
        "family": "Sofia Sans Semi Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Solitreo": {
        "family": "Solitreo",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Solway": {
        "family": "Solway",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "700",
            "800"
        ]
    },
    "Sometype-Mono": {
        "family": "Sometype Mono",
        "category": "monospace",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Song-Myung": {
        "family": "Song Myung",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Sono": {
        "family": "Sono",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Sonsie-One": {
        "family": "Sonsie One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sora": {
        "family": "Sora",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Sorts-Mill-Goudy": {
        "family": "Sorts Mill Goudy",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Source-Code-Pro": {
        "family": "Source Code Pro",
        "category": "monospace",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Source-Sans-3": {
        "family": "Source Sans 3",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Source-Serif-4": {
        "family": "Source Serif 4",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Space-Grotesk": {
        "family": "Space Grotesk",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Space-Mono": {
        "family": "Space Mono",
        "category": "monospace",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Special-Elite": {
        "family": "Special Elite",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Spectral": {
        "family": "Spectral",
        "category": "serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic"
        ]
    },
    "Spectral-SC": {
        "family": "Spectral SC",
        "category": "serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic"
        ]
    },
    "Spicy-Rice": {
        "family": "Spicy Rice",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Spinnaker": {
        "family": "Spinnaker",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Spirax": {
        "family": "Spirax",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Splash": {
        "family": "Splash",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Spline-Sans": {
        "family": "Spline Sans",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Spline-Sans-Mono": {
        "family": "Spline Sans Mono",
        "category": "monospace",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Squada-One": {
        "family": "Squada One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Square-Peg": {
        "family": "Square Peg",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Sree-Krushnadevaraya": {
        "family": "Sree Krushnadevaraya",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Sriracha": {
        "family": "Sriracha",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Srisakdi": {
        "family": "Srisakdi",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Staatliches": {
        "family": "Staatliches",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Stalemate": {
        "family": "Stalemate",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Stalinist-One": {
        "family": "Stalinist One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Stardos-Stencil": {
        "family": "Stardos Stencil",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Stick": {
        "family": "Stick",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Stick-No-Bills": {
        "family": "Stick No Bills",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Stint-Ultra-Condensed": {
        "family": "Stint Ultra Condensed",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Stint-Ultra-Expanded": {
        "family": "Stint Ultra Expanded",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Stoke": {
        "family": "Stoke",
        "category": "serif",
        "variants": [
            "300",
            "regular"
        ]
    },
    "Strait": {
        "family": "Strait",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Style-Script": {
        "family": "Style Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Stylish": {
        "family": "Stylish",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Sue-Ellen-Francisco": {
        "family": "Sue Ellen Francisco",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Suez-One": {
        "family": "Suez One",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Sulphur-Point": {
        "family": "Sulphur Point",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "700"
        ]
    },
    "Sumana": {
        "family": "Sumana",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Sunflower": {
        "family": "Sunflower",
        "category": "sans-serif",
        "variants": [
            "300",
            "500",
            "700"
        ]
    },
    "Sunshiney": {
        "family": "Sunshiney",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Supermercado-One": {
        "family": "Supermercado One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Sura": {
        "family": "Sura",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Suranna": {
        "family": "Suranna",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Suravaram": {
        "family": "Suravaram",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Suwannaphum": {
        "family": "Suwannaphum",
        "category": "serif",
        "variants": [
            "100",
            "300",
            "regular",
            "700",
            "900"
        ]
    },
    "Swanky-and-Moo-Moo": {
        "family": "Swanky and Moo Moo",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Syncopate": {
        "family": "Syncopate",
        "category": "sans-serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Syne": {
        "family": "Syne",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Syne-Mono": {
        "family": "Syne Mono",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Syne-Tactile": {
        "family": "Syne Tactile",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Tai-Heritage-Pro": {
        "family": "Tai Heritage Pro",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Tajawal": {
        "family": "Tajawal",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "700",
            "800",
            "900"
        ]
    },
    "Tangerine": {
        "family": "Tangerine",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Tapestry": {
        "family": "Tapestry",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Taprom": {
        "family": "Taprom",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Tauri": {
        "family": "Tauri",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Taviraj": {
        "family": "Taviraj",
        "category": "serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Teko": {
        "family": "Teko",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Tektur": {
        "family": "Tektur",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Telex": {
        "family": "Telex",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Tenali-Ramakrishna": {
        "family": "Tenali Ramakrishna",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Tenor-Sans": {
        "family": "Tenor Sans",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Text-Me-One": {
        "family": "Text Me One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Texturina": {
        "family": "Texturina",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Thasadith": {
        "family": "Thasadith",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "The-Girl-Next-Door": {
        "family": "The Girl Next Door",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "The-Nautigal": {
        "family": "The Nautigal",
        "category": "handwriting",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Tienne": {
        "family": "Tienne",
        "category": "serif",
        "variants": [
            "regular",
            "700",
            "900"
        ]
    },
    "Tillana": {
        "family": "Tillana",
        "category": "display",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Tilt-Neon": {
        "family": "Tilt Neon",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Tilt-Prism": {
        "family": "Tilt Prism",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Tilt-Warp": {
        "family": "Tilt Warp",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Timmana": {
        "family": "Timmana",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Tinos": {
        "family": "Tinos",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Tiro-Bangla": {
        "family": "Tiro Bangla",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Tiro-Devanagari-Hindi": {
        "family": "Tiro Devanagari Hindi",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Tiro-Devanagari-Marathi": {
        "family": "Tiro Devanagari Marathi",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Tiro-Devanagari-Sanskrit": {
        "family": "Tiro Devanagari Sanskrit",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Tiro-Gurmukhi": {
        "family": "Tiro Gurmukhi",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Tiro-Kannada": {
        "family": "Tiro Kannada",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Tiro-Tamil": {
        "family": "Tiro Tamil",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Tiro-Telugu": {
        "family": "Tiro Telugu",
        "category": "serif",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Titan-One": {
        "family": "Titan One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Titillium-Web": {
        "family": "Titillium Web",
        "category": "sans-serif",
        "variants": [
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "900"
        ]
    },
    "Tomorrow": {
        "family": "Tomorrow",
        "category": "sans-serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Tourney": {
        "family": "Tourney",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Trade-Winds": {
        "family": "Trade Winds",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Train-One": {
        "family": "Train One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Trirong": {
        "family": "Trirong",
        "category": "serif",
        "variants": [
            "100",
            "100italic",
            "200",
            "200italic",
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic",
            "900",
            "900italic"
        ]
    },
    "Trispace": {
        "family": "Trispace",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Trocchi": {
        "family": "Trocchi",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Trochut": {
        "family": "Trochut",
        "category": "display",
        "variants": [
            "regular",
            "italic",
            "700"
        ]
    },
    "Truculenta": {
        "family": "Truculenta",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Trykker": {
        "family": "Trykker",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Tsukimi-Rounded": {
        "family": "Tsukimi Rounded",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Tulpen-One": {
        "family": "Tulpen One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Turret-Road": {
        "family": "Turret Road",
        "category": "display",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "700",
            "800"
        ]
    },
    "Twinkle-Star": {
        "family": "Twinkle Star",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Ubuntu": {
        "family": "Ubuntu",
        "category": "sans-serif",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "700",
            "700italic"
        ]
    },
    "Ubuntu-Condensed": {
        "family": "Ubuntu Condensed",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Ubuntu-Mono": {
        "family": "Ubuntu Mono",
        "category": "monospace",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Uchen": {
        "family": "Uchen",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Ultra": {
        "family": "Ultra",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Unbounded": {
        "family": "Unbounded",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Uncial-Antiqua": {
        "family": "Uncial Antiqua",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Underdog": {
        "family": "Underdog",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Unica-One": {
        "family": "Unica One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "UnifrakturCook": {
        "family": "UnifrakturCook",
        "category": "display",
        "variants": [
            "700"
        ]
    },
    "UnifrakturMaguntia": {
        "family": "UnifrakturMaguntia",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Unkempt": {
        "family": "Unkempt",
        "category": "display",
        "variants": [
            "regular",
            "700"
        ]
    },
    "Unlock": {
        "family": "Unlock",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Unna": {
        "family": "Unna",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Updock": {
        "family": "Updock",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Urbanist": {
        "family": "Urbanist",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "VT323": {
        "family": "VT323",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Vampiro-One": {
        "family": "Vampiro One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Varela": {
        "family": "Varela",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Varela-Round": {
        "family": "Varela Round",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Varta": {
        "family": "Varta",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Vast-Shadow": {
        "family": "Vast Shadow",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Vazirmatn": {
        "family": "Vazirmatn",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Vesper-Libre": {
        "family": "Vesper Libre",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "700",
            "900"
        ]
    },
    "Viaoda-Libre": {
        "family": "Viaoda Libre",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Vibes": {
        "family": "Vibes",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Vibur": {
        "family": "Vibur",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Victor-Mono": {
        "family": "Victor Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Vidaloka": {
        "family": "Vidaloka",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Viga": {
        "family": "Viga",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Vina-Sans": {
        "family": "Vina Sans",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Voces": {
        "family": "Voces",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Volkhov": {
        "family": "Volkhov",
        "category": "serif",
        "variants": [
            "regular",
            "italic",
            "700",
            "700italic"
        ]
    },
    "Vollkorn": {
        "family": "Vollkorn",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Vollkorn-SC": {
        "family": "Vollkorn SC",
        "category": "serif",
        "variants": [
            "regular",
            "600",
            "700",
            "900"
        ]
    },
    "Voltaire": {
        "family": "Voltaire",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Vujahday-Script": {
        "family": "Vujahday Script",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Waiting-for-the-Sunrise": {
        "family": "Waiting for the Sunrise",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Wallpoet": {
        "family": "Wallpoet",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Walter-Turncoat": {
        "family": "Walter Turncoat",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Warnes": {
        "family": "Warnes",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Water-Brush": {
        "family": "Water Brush",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Waterfall": {
        "family": "Waterfall",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Wavefont": {
        "family": "Wavefont",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Wellfleet": {
        "family": "Wellfleet",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Wendy-One": {
        "family": "Wendy One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Whisper": {
        "family": "Whisper",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "WindSong": {
        "family": "WindSong",
        "category": "handwriting",
        "variants": [
            "regular",
            "500"
        ]
    },
    "Wire-One": {
        "family": "Wire One",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Wix-Madefor-Display": {
        "family": "Wix Madefor Display",
        "category": "sans-serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "800"
        ]
    },
    "Wix-Madefor-Text": {
        "family": "Wix Madefor Text",
        "category": "sans-serif",
        "variants": [
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic",
            "800",
            "800italic"
        ]
    },
    "Work-Sans": {
        "family": "Work Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Workbench": {
        "family": "Workbench",
        "category": "monospace",
        "variants": [
            "regular"
        ]
    },
    "Xanh-Mono": {
        "family": "Xanh Mono",
        "category": "monospace",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Yaldevi": {
        "family": "Yaldevi",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Yanone-Kaffeesatz": {
        "family": "Yanone Kaffeesatz",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700"
        ]
    },
    "Yantramanav": {
        "family": "Yantramanav",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "regular",
            "500",
            "700",
            "900"
        ]
    },
    "Yatra-One": {
        "family": "Yatra One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Yellowtail": {
        "family": "Yellowtail",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Yeon-Sung": {
        "family": "Yeon Sung",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Yeseva-One": {
        "family": "Yeseva One",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Yesteryear": {
        "family": "Yesteryear",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Yomogi": {
        "family": "Yomogi",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Young-Serif": {
        "family": "Young Serif",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Yrsa": {
        "family": "Yrsa",
        "category": "serif",
        "variants": [
            "300",
            "regular",
            "500",
            "600",
            "700",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic"
        ]
    },
    "Ysabeau": {
        "family": "Ysabeau",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Ysabeau-Infant": {
        "family": "Ysabeau Infant",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Ysabeau-Office": {
        "family": "Ysabeau Office",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900",
            "100italic",
            "200italic",
            "300italic",
            "italic",
            "500italic",
            "600italic",
            "700italic",
            "800italic",
            "900italic"
        ]
    },
    "Ysabeau-SC": {
        "family": "Ysabeau SC",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "regular",
            "500",
            "600",
            "700",
            "800",
            "900"
        ]
    },
    "Yuji-Boku": {
        "family": "Yuji Boku",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Yuji-Hentaigana-Akari": {
        "family": "Yuji Hentaigana Akari",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Yuji-Hentaigana-Akebono": {
        "family": "Yuji Hentaigana Akebono",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Yuji-Mai": {
        "family": "Yuji Mai",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Yuji-Syuku": {
        "family": "Yuji Syuku",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Yusei-Magic": {
        "family": "Yusei Magic",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "ZCOOL-KuaiLe": {
        "family": "ZCOOL KuaiLe",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "ZCOOL-QingKe-HuangYou": {
        "family": "ZCOOL QingKe HuangYou",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "ZCOOL-XiaoWei": {
        "family": "ZCOOL XiaoWei",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Zen-Antique": {
        "family": "Zen Antique",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Zen-Antique-Soft": {
        "family": "Zen Antique Soft",
        "category": "serif",
        "variants": [
            "regular"
        ]
    },
    "Zen-Dots": {
        "family": "Zen Dots",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Zen-Kaku-Gothic-Antique": {
        "family": "Zen Kaku Gothic Antique",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "700",
            "900"
        ]
    },
    "Zen-Kaku-Gothic-New": {
        "family": "Zen Kaku Gothic New",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "700",
            "900"
        ]
    },
    "Zen-Kurenaido": {
        "family": "Zen Kurenaido",
        "category": "sans-serif",
        "variants": [
            "regular"
        ]
    },
    "Zen-Loop": {
        "family": "Zen Loop",
        "category": "display",
        "variants": [
            "regular",
            "italic"
        ]
    },
    "Zen-Maru-Gothic": {
        "family": "Zen Maru Gothic",
        "category": "sans-serif",
        "variants": [
            "300",
            "regular",
            "500",
            "700",
            "900"
        ]
    },
    "Zen-Old-Mincho": {
        "family": "Zen Old Mincho",
        "category": "serif",
        "variants": [
            "regular",
            "500",
            "600",
            "700",
            "900"
        ]
    },
    "Zen-Tokyo-Zoo": {
        "family": "Zen Tokyo Zoo",
        "category": "display",
        "variants": [
            "regular"
        ]
    },
    "Zeyada": {
        "family": "Zeyada",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Zhi-Mang-Xing": {
        "family": "Zhi Mang Xing",
        "category": "handwriting",
        "variants": [
            "regular"
        ]
    },
    "Zilla-Slab": {
        "family": "Zilla Slab",
        "category": "serif",
        "variants": [
            "300",
            "300italic",
            "regular",
            "italic",
            "500",
            "500italic",
            "600",
            "600italic",
            "700",
            "700italic"
        ]
    },
    "Zilla-Slab-Highlight": {
        "family": "Zilla Slab Highlight",
        "category": "serif",
        "variants": [
            "regular",
            "700"
        ]
    }
}
